import { render, staticRenderFns } from "./zxbuy.vue?vue&type=template&id=57fcbaf5&scoped=true&"
import script from "./zxbuy.vue?vue&type=script&lang=js&"
export * from "./zxbuy.vue?vue&type=script&lang=js&"
import style0 from "./zxbuy.vue?vue&type=style&index=0&id=57fcbaf5&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fcbaf5",
  null
  
)

export default component.exports